import { ComponentStyleConfig } from "@chakra-ui/react";

const CalendarMonthTheme: ComponentStyleConfig = {
  baseStyle: {
    month: {
      p: "16px",
      _first: {
        _notLast: {
          paddingRight: "24px",
          borderRightWidth: "1px",
        },
      },
    },
    name: {
      color: "gray.700",
      fontSize: "14px",
      fontWeight: 500,
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    weekday: {
      color: "gray.700",
      fontSize: "14px",
      fontWeight: 500,
    },
    week: {
      height: "40px",
      alignItems: "center",
    },
  },
};

export default CalendarMonthTheme;
